<template>
    <v-layout align-center justify-center>

        <v-flex xs12 sm8 md4>
            <v-card class="elevation-24">
                <v-toolbar
                        flat
                        height="70"
                >
                    <v-spacer></v-spacer>
                    <v-img
                            src="../static/img/Redemption-Logo-Remastered-R-76x76-min.png"
                            lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAMAAADwSaEZAAAALVBMVEX/AABHcEz/AAD/AADeAAAkAAFuURwGAwLn2QLGtwc4HAGqmAyGdQ2BAAHGAACpilCxAAAABnRSTlP/AGi5LY/jUnJwAAADyElEQVRYw+2Y29LrIAiFU3Urivr+j7sF8dSmzGSml793TevXJeICc71+OK4/2OvlzKOhw+z1ZFgV5h6xLnf9UJgas6fCVJh5KEyFPRNmVNgzYZeeZ+t3tbRRz7klnU+MCjNzVpBRNhR9Tmf4NZhds0LyPm00ephyCPUIvwJza1aEGCNAFlolbgZIu1SnwpqwSigEzJ5GJtpEoY95W6dVD7rrLIRO6rQQKqF8Q3mPkdi7sK8wQ2tMEDHGOHjAW+EhyscVNKtbUPtFCggEynN2g6UGX+yy5cV3mGGYjARDSuKdENgWNN0cedcYRGkGEjMERAxj2StoRoVJwtaeHqIMITZcCBn9W9CcCtuNLI3ZGCPEHIJ/D5pVa8BuZHWtMvkItPQZNN+D5lTYKUyUtKmAmWEjaMhBs2p12oRRkspcCCyshIC4sngL/z3M7KiAXVgTFVlKClmCFnk7rV43d5/pR0eSjCM+dhfBswsZFWY2n4GR8FNY7XmHdOx5M/WKPjZR8j2v7E8hiWcA0vf1iNgdzCzLioAjYTFEyvh+0CHS92fC3sNsXyH/fRo7Byl1Ai98c12rNi6OV0hxz+DDEoYkjBfu93LgVJi9eE7m/Uq7MM9Wmad9fwj7gDneehyJJCcphoyQ+2MWfJ1G9gVmKGBxHBihxhRoM+RI4rJYqzd73RTzZv0iDNeTJq3cCXuHmWvQNhgf8bhocsDPhL2Bzco7nZ4TNkfICOiPA/4h7A1mpu8kOISRKaa59hE0p8LscsSIS5iYoocTZtVu2316NR9xoCiVZbGQQr0RdsLs1uUspydh5D3LYrsyq94D3HUDm97TYPGAGRVmDti7KZ6wz7x4gx1lRE7l8J66wTLbtVFhZms750TxHsr4+QwxpOvS70726DthtAAowmYBpTCmO2EbzOzdqjiERwDynpDKVn2p+FanwuxEZYi4TrmPkKUdWrAQ/mkwJ9Y/RW2uATEEkhOXshA02LJ+/zkiAGAYqRcxQgjuO8x1Wbcojh2u9ofKlgoz3A7HfM/KXEXmcY1UNZVlFpGVkZbEY3NDLm6jx+C+ICi7+Y+rG1I355NcSlAa40xmFuo4rtSu3O7lhFHHD5BnT9x5XFiQm+zRjuavsibMNJiQUimVR+8QMgsp0kIiV/Pi1FcRdoD2W1/tZWp2FSmkvmCrvtdw/MvycR8tx82wBrkXOhX29S1BCfs9sElNtw57wJTLcr29jCuw55dxBfb4LYEC+5kwgtlfCWsw8/QljQZ7+vZIg7nfCXtdPxT2up69CHR/r1Z/DPsPUbxCTww0tegAAAAASUVORK5CYII="
                            max-height="70"
                            max-width="70"
                            contain
                            class="pr-5"
                    ></v-img>
                    <v-toolbar-title>RedemptionDB</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>

                    <v-form v-if='options.isLoggingIn' ref="form" v-model="loginValid">

                        <v-text-field
                                color="success"
                                label="Email"
                                prepend-icon="email"
                                autocomplete="username"
                                :rules="emailRules"
                                autofocus
                                v-model="form.email"
                                @keydown.enter="login"
                        ></v-text-field>

                        <v-text-field
                                color="success"
                                label="Password"
                                prepend-icon="lock"
                                autocomplete="current-password"
                                :rules="passwordRules"
                                v-model="form.password"
                                :type="showPassword ? 'text' : 'password'"
                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="showPassword = !showPassword"
                                @keydown.enter="login"
                        ></v-text-field>
                    </v-form>
                    <v-form v-else ref="form" v-model="registerValid">
                        <v-text-field
                                color="success"
                                label="Username"
                                prepend-icon="person"
                                :rules="nameRules"
                                v-model="form.username"
                                v-if='!options.isLoggingIn'
                                @keydown.enter="register"
                        ></v-text-field>

                        <v-text-field
                                color="success"
                                label="Email"
                                prepend-icon="email"
                                autocomplete="username"
                                :rules="emailRules"
                                autofocus
                                v-model="form.email"
                                @keydown.enter="register"
                        ></v-text-field>

                        <v-text-field
                                color="success"
                                label="Password"
                                prepend-icon="lock"
                                autocomplete="current-password"
                                :rules="passwordRules"
                                v-model="form.password"
                                :type="showPassword ? 'text' : 'password'"
                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="showPassword = !showPassword"
                                @keydown.enter="register"
                        ></v-text-field>

                        <v-text-field
                                color="success"
                                label="Confirm Password"
                                prepend-icon="lock"
                                autocomplete="current-password"
                                :rules="confirmPasswordRules"
                                v-model="form.confirmationPassword"
                                :type="showConfirmationPassword ? 'text' : 'password'"
                                :append-icon="showConfirmationPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="showConfirmationPassword = !showConfirmationPassword"
                                @keydown.enter="register"
                        ></v-text-field>
                    </v-form>

                    <v-card-actions v-if="options.isLoggingIn">
                        <v-btn block color="success" :loading="loading" :disabled="!loginValid || loading"
                               @click="login">
                            Log in
                            <template v-slot:loader>
                                <span class="custom-loader">
                                    <v-icon>cached</v-icon>
                                </span>
                            </template>
                        </v-btn>
                    </v-card-actions>
                    <v-card-actions v-else>
                        <v-btn block color="success" :loading="loading" :disabled="!registerValid || loading"
                               @click="register">
                            Register
                            <template v-slot:loader>
                                <span class="custom-loader">
                                    <v-icon>cached</v-icon>
                                </span>
                            </template>
                        </v-btn>

                    </v-card-actions>

                    <!--                    <div v-if="error !== null" class="text-center">-->
                    <!--                        <v-sheet class="pa-3 red&#45;&#45;text">{{ error.message }}</v-sheet>-->
                    <!--                    </div>-->

                    <div v-if="error">
                        <app-alert type="error" @dismissed="onDismissed" :text="error.message"></app-alert>
                    </div>

                    <div class="text-center" v-if='options.isLoggingIn'>
                        <v-sheet class="pa-3">
                            Don't have an account?
                            <v-btn class="ml-4" @click='toggleLoginState'>Register</v-btn>
                        </v-sheet>
                    </div>
                    <div class="text-center" v-else>
                        <v-sheet class="pa-3">
                            Already have an account?
                            <v-btn class="ml-4" @click='toggleLoginState'>Log in</v-btn>
                        </v-sheet>
                    </div>

                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<style>
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }
</style>

<script>

    export default {
        name: "LoginRegister",
        data() {
            return {
                registerValid: false,
                loginValid: false,

                nameRules: [
                    v => !!v || 'Name is required',
                ],
                emailRules: [
                    v => !!v || 'E-mail is required',
                    v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                ],
                passwordRules: [
                    v => !!v || 'Password is required',
                    v => (v && v.length >= 10) || 'Password must be more than 10 characters',
                ],
                confirmPasswordRules: [
                    v => !!v || 'Must confirm password',
                    v => (v && v === this.form.password) || 'Passwords must match',
                ],

                form: {
                    username: "",
                    email: "",
                    password: "",
                    confirmationPassword: ""
                },

                showPassword: false,
                showConfirmationPassword: false,
                options: {
                    isLoggingIn: true,
                },
            }
        },
        computed: {
            user() {
                return this.$store.getters.user;
            },
            error() {
                return this.$store.getters.error;
            },
            loading() {
                return this.$store.getters.loading;
            }
        },
        watch: {
            user(value) {
                if (value !== null && value !== undefined) {
                    this.$router.push("/");
                }
            }
        },
        methods: {
            register() {
                this.$store.dispatch('signUpUser', {
                    email: this.form.email,
                    password: this.form.password,
                    username: this.form.username
                });
            },
            login() {
                this.$store.dispatch('signInUser', {
                    email: this.form.email,
                    password: this.form.password});
            },
            onDismissed() {
                this.$store.dispatch("clearError");
            },
            toggleLoginState() {
                this.options.isLoggingIn = !this.options.isLoggingIn;
                this.$store.dispatch("clearError");
                this.reset();
            },
            reset() {
                this.$refs.form.reset();
                this.$refs.form.resetValidation();
            },
        },
    }
</script>

<style scoped>

</style>